import dayjs, { Dayjs } from 'dayjs'
import { EmployeeVacation } from '../types/utils/VacationTypes'
import { getDaysOfTheMonth } from './worklogUtils'

export const calculateVacationCount = (checkDate: string, employeeVacation: EmployeeVacation[]) => {
  return employeeVacation.reduce(
    (totalCount, employeeData) =>
      totalCount +
      employeeData.vacation.filter(vacation =>
        dayjs(checkDate).isBetween(vacation.startDate, vacation.endDate, undefined, '[]')
      ).length,
    0
  )
}

export const calculateTotalVacationCount = (selectedDate: Dayjs, employeeVacation: EmployeeVacation[]) => {
  const daysInSelectedMonth = getDaysOfTheMonth(selectedDate).map(dayObj => dayObj.date.format('YYYY-MM-DD'))
  return daysInSelectedMonth.reduce(
    (accumulatedVacations, dayString) => accumulatedVacations + calculateVacationCount(dayString, employeeVacation),
    0
  )
}
